import { useCallback, useEffect, useState } from "react";
import { actionGetDashboard } from "../../actions/Dashboard.action";
import { useDispatch, useSelector } from "react-redux";
import { serviceGetTopPrograms, serviceGetTopUsers } from "../../services/Dashboard.service";
import RouteName from "../../routes/Route.name";
import history from "../../libs/history.utils";

const useDashboardHook = () => {
  const dispatch = useDispatch();
  const { dashboard } = useSelector((state) => state?.dashboard);
  const [usersData, setUsersData] = useState([]);
  const [programData, setProgramData] = useState([]);


  useEffect(() => {
    dispatch(actionGetDashboard());

    serviceGetTopUsers().then((res) => {
      if (!res.error) {
        const resData = res?.data;
        setUsersData(resData);
      }
    });

    serviceGetTopPrograms().then((res) => {
      if (!res.error) {
        const resData = res?.data;
        setProgramData(resData);
      }
    });

  }, [dispatch]);

  const handleDetail = useCallback((type) => {
    history.push({pathname: `${ RouteName.APP_DETAIL}${type?.user_id}`, state: { appusers:type?.user }})
  }, []);

  return {
    dashboard,
    usersData,
    programData,
    handleDetail
  };
};

export default useDashboardHook;
